import { createEmptyAddress } from '@/helpers/address'

const setCheckoutData = function (state, data) {
    if (!data.shippingContact) data.shippingContact = createEmptyAddress()

    if (!data.billingContact) data.billingContact = createEmptyAddress()

    state.data = data
}

const subscribe = function (state) {
    state.data.shippingContact.subscribe = true
}

const setReceiptData = function (state, receiptObj) {
    state.receiptData = receiptObj

    if (state.hasOrderBeenPlaced) {
        const { indexName, queryID } = this.$search.catalog.state
        // if hasOrderBeenPlaced is true then it means that we came here right after the checkout was complete
        this.$uiEvents.$emit('orderPlaced', { receiptObj, indexName, queryID })
    }
}

const setHasOrderBeenPlaced = function (state, data) {
    state.hasOrderBeenPlaced = data
}

const setIsProcessing = function (state, data) {
    state.isProcessing = data
}

const setIsAffirmPayFlow = function (state, bool) {
    state.isAffirmPayFlow = bool
}

const setAutocompleteOff = function (state, bool) {
    state.isAutocompleteOff = bool
}

export default {
    setCheckoutData,
    setReceiptData,
    subscribe,
    setHasOrderBeenPlaced,
    setIsProcessing,
    setIsAffirmPayFlow,
    setAutocompleteOff,
}
